<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <select :id="getId" v-model="currentValue" class="form-control">
            <option value="black">Zwart</option>
            <option value="white">Wit</option>
        </select>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    export default {
        mixins: [
            fieldInfo
        ],
    }
</script>
